import { formatPrice } from "~/helpers/formatting/price";
import type { RawProduct, Product } from "./types.js";

export function useProductNameFormatter(product: Product) {
	const productNameWithoutBrand = computed(() => {
		return product.productName.replace(new RegExp(`^${product.brand} `, "i"), "");
	});

	return {
		productNameWithoutBrand,
	};
}

export function useProductPriceFormatter(rawProduct: Ref<RawProduct>) {
	const formattedPrice = computed(() => {
		return formatPrice.oneTime(rawProduct.value.priceWithVat, { round: true, prefix: false });
	});

	const formattedSalePrice = computed(() => {
		return rawProduct.value.salePriceWithVat
			? formatPrice.oneTime(rawProduct.value.salePriceWithVat, { round: true, prefix: false })
			: undefined;
	});

	return {
		formattedPrice,
		formattedSalePrice,
	};
}

export function useAddToCartFormatter(product: RawProduct) {
	return {
		name: product.title,
		id: product.id,
		prices: product?.prices,
		price: product.priceWithVat,
		priceWithoutVat: product.price,
		salePrice: product?.salePriceWithVat,
		salePriceWithoutVat: product?.salePrice,
		image: product.imageLink,
		category: product.category,
		sapProductId: product?.sapProductId,
		brand: product.brand,
	};
}
